"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const constants_1 = require("../../constants/constants");
const store_1 = require("../../store");
const authSlice_1 = require("../../features/auth/authSlice");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles_1 = __importDefault(require("../../styles/styles"));
const utils_1 = require("../../utils/utils");
const icon_1 = __importStar(require("../icon/icon"));
const labelButton_1 = __importDefault(require("../labelButton/labelButton"));
const logo_1 = __importDefault(require("../logo/logo"));
const primaryButton_1 = __importDefault(require("../primaryButton/primaryButton"));
const spinner_1 = __importDefault(require("../spinner/spinner"));
const text_1 = __importStar(require("../text/text"));
const textStyles_1 = __importDefault(require("../text/textStyles"));
const pressableElement_1 = __importDefault(require("../pressables/pressableElement"));
const AppMessageLayout = ({ hasLogo, icon, textTitle, textSubtitle, buttonTextPrimary, onPressPrimary, eventNamePrimary, buttonTextSecundary, onPressSecundary, eventNameSecundary, preLinkTextSecundary, errors = null, isLoading = false, message = '', hasLogout = false, primaryButtonColor = colors_1.default.COLOR_PRIMARY, showButton = true, }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.flexDirectionColumn] }, isLoading ? (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.centerChildHorizontalVertical, styles_1.default.flexOne] },
        react_1.default.createElement(spinner_1.default, null))) : (react_1.default.createElement(react_1.default.Fragment, null,
        hasLogout && (react_1.default.createElement(pressableElement_1.default, { onPress: () => dispatch((0, authSlice_1.logout)()), eventName: "logout", style: [
                styles_1.default.minimumMarginBetweenElementsVertically,
                { alignSelf: 'flex-end', alignContent: 'flex-end', paddingRight: 10 },
            ] },
            react_1.default.createElement(icon_1.default, { name: icon_1.LOGOUT_ICON }))),
        !!errors && (react_1.default.createElement(react_native_1.View, { style: [
                styles_1.default.mainContainerPadding,
                styles_1.default.minimumMarginBetweenElementsVertically,
                styles_1.default.flexDirectionColumn,
                styles_1.default.centerChildHorizontalVertical,
            ] },
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: colors_1.default.COLOR_CRITICAL }, `${constants_1.DEFAULT_ERROR_MESSAGE} ${(0, utils_1.getError)('non_field_errors', errors) ? (0, utils_1.getError)('non_field_errors', errors) : ''}`))),
        message ? (react_1.default.createElement(react_native_1.View, { style: [
                styles_1.default.mainContainerPadding,
                styles_1.default.minimumMarginBetweenElementsVertically,
                styles_1.default.flexDirectionColumn,
                styles_1.default.centerChildHorizontalVertical,
            ] },
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: colors_1.default.COLOR_PRIMARY }, message))) : (react_1.default.createElement(react_native_1.View, null)),
        hasLogo && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.centerChildHorizontalVertical },
            react_1.default.createElement(logo_1.default, { fixedSize: true }))),
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.flexDirectionRow] },
            react_1.default.createElement(react_native_1.View, { style: [
                    styles_1.default.flexTwo,
                    styles_1.default.centerChildHorizontalVertical,
                    styles_1.default.mainContainerPadding,
                ] },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.minimumMarginBetweenElementsVertically },
                    react_1.default.createElement(icon_1.default, { name: icon })),
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.minimumMarginBetweenElementsVertically },
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.minimumMarginBetweenElementsVertically },
                        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_TITLE, style: [textStyles_1.default.bold, textStyles_1.default.centerText] }, textTitle)),
                    react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: colors_1.default.COLOR_GRAY_DARK, style: textStyles_1.default.centerText }, textSubtitle)))),
        showButton && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.mainContainerPadding] },
            react_1.default.createElement(primaryButton_1.default, { title: buttonTextPrimary, onPress: onPressPrimary, eventName: eventNamePrimary, color: primaryButtonColor }))),
        !!(onPressSecundary && buttonTextSecundary && eventNameSecundary) && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
                react_1.default.createElement(labelButton_1.default, { title: buttonTextSecundary, onPress: onPressSecundary, disabled: false, textColor: colors_1.default.COLOR_PRIMARY, eventName: eventNameSecundary, linkStyle: [textStyles_1.default.underline], positionStyle: [
                        styles_1.default.flexDirectionRow,
                        styles_1.default.centerChildHorizontalVertical,
                    ], textBeforeLink: preLinkTextSecundary }))))))));
};
AppMessageLayout.defaultProps = {
    hasLogo: undefined,
    buttonTextSecundary: undefined,
    onPressSecundary: undefined,
    eventNameSecundary: undefined,
    preLinkTextSecundary: undefined,
};
exports.default = AppMessageLayout;
